import { computed } from 'vue'
import useGrupoDePermissoes from '@/stores/grupoDePermissoesStore'

import type { Router } from 'vue-router'

/**
 * Atalho para checagem de permissões do usuário, evitando declarar o
 * grupoDePermissoesStore em cada arquivo que apenas verifica acesso.
 *
 * Uso: const { hasAccess } = usePermissions()
 *      hasAccess('Seções', 'Conteúdo')
 */
export function usePermissions() {
  const store = useGrupoDePermissoes()

  const hasAccess = (permission: string | string[], parent?: string) =>
    store.canUserAccess(permission, parent)

  const permissions = computed(() => store.permissions)
  const iteration = computed(() => store.iteration)
  const isPermissionsEmpty = () => store.isPermissionsEmpty()
  const getFirstRouteAccess = (router: Router) => store.getFirstRouteAccess(router)

  return {
    hasAccess,
    permissions,
    iteration,
    isPermissionsEmpty,
    getFirstRouteAccess
  }
}

export default usePermissions
